import { Icon, Reveal } from '@nexa/ui';

export interface SkillsBannerProps {
  readonly label: string;
  readonly body: string;
}

/**
 * Banner "Skills" — `template.html:939-943`.
 *
 * `reference.md` §3 tả banner này như thể nó nằm trên nền SÁNG (nền `surface-muted`, mô tả
 * `ink-500`, nhãn cỡ 16). Đo lại thiết kế thì nó nằm trên gradient navy: nền và viền đều là
 * trắng-alpha, nhãn 15px, mô tả trắng-alpha 72%. Đi theo `template.html`.
 *
 * `flex-wrap` là của thiết kế (:939), không phải phần thêm cho mobile — nhờ nó banner tự xếp dọc
 * khi hẹp. Đây cũng đúng loại lỗi mà rig `visual` mù (nó thấy tràn, không thấy wrap), nên bậc
 * này phải nghiệm thu bằng mắt.
 */
export function SkillsBanner({ label, body }: SkillsBannerProps) {
  return (
    <Reveal className="mt-5 flex flex-wrap items-center gap-3.5 rounded-card border border-[var(--on-dark-line-20)] bg-[var(--on-dark-fill-05)] px-6 py-5">
      <Icon name="wand-sparkles" size={20} className="text-white" />
      <span className="text-title-sm font-semibold text-white">{label}</span>
      <span className="text-body text-[var(--on-dark-text-72)]">{body}</span>
    </Reveal>
  );
}
